<section class="bg-half-170 d-table w-100 padding_class">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="title-heading mt-4">
                    <h1 class="heading mb-3"><span class="text-primary fw-bold">EMI &amp; Cash</span> Collection Service</h1>
                    <p class="para-desc text-muted">Become cash or EMI collection center of your location and increase your monthly income. Get commission on collecting cash or EMI installment for various NBFCs and institutions.</p>
                </div>

               <!-- <div class="subcribe-form mt-4 pt-2">
                    <form>
                        <input type="email" id="email" name="email" class="border bg-white rounded-pill" required placeholder="Email Address">
                        <button type="submit" class="btn btn-pills btn-primary">Get Started</button>
                    </form>
                </div>
                
                <div class="form-check mt-3">
                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                    <label class="form-check-label" for="flexCheckDefault">I Accept <a href="#" class="text-primary">Terms And Condition</a></label>
                </div> -->
            </div>

            <div class="col-md-6">
                <img src="../../../../assets/images/EMI-image-1.png" alt="" width="100%">
            </div><!--end col--> 
        </div><!--end row-->
    </div><!--end container-->
</section>


<div class="pb-70"style="    background: linear-gradient(
    -45deg, rgba(21,64,214,1), rgba(42,188,238,1),rgba(21,64,214,1),rgba(42,188,238,1) ); padding:50px; animation: gradient 15s ease infinite; @keyframes gradient {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }">
    
               <h3 style="
               text-align: center;color:#fff;">Become a Retailer and Earn upto Rs.1 Lakh per month.</h3>
                <div class="" style="
                text-align: center;color:#fff;"> 
                       <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#myModal1">
                            <div class="btn btn-primary">Sign Up</div>
                        </a>
                    </div>
            </div>



            <section class=" bg-light">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-12 text-center">
                            <div class="section-title mb-4 pb-2">
                                
                                <h4 class="title mb-4">Awesome Features of Cash Collection</h4>
                                <p class="text-muted para-desc mb-0 mx-auto">Cash Collection service has numerous benefits which makes it one among the <span class="text-primary fw-bold">best business solutions.</span></p>
                            </div>
                        </div><!--end col-->
                    </div><!--end row-->
    
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center">
                                <div class="icons text-primary text-center mx-auto">
                                    <i class="uil uil-airplay d-block rounded h3 mb-0"></i>
                                </div>
    
                                <div class="card-body p-0 content">
                                    <h5 class="mt-4"><a href="javascript:void(0)" class="title text-dark">40+ Partners</a></h5>
                                    <p class="text-muted">Customers and collection agents can deposit EMIs for 40+ partners at your store and you get commission on every transaction.</p>
    
                                    <!-- <a href="javascript:void(0)" class="text-primary">Read More <i class="uil uil-angle-right-b align-middle"></i></a> -->
                                </div>
                            </div>
                        </div><!--end col-->
                        
                        <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center">
                                <div class="icons text-primary text-center mx-auto">
                                    <i class="uil uil-clipboard-alt d-block rounded h3 mb-0"></i>
                                </div>
    
                                <div class="card-body p-0 content">
                                    <h5 class="mt-4"><a href="javascript:void(0)" class="title text-dark">24/7 Operational</a></h5>
                                    <p class="text-muted">Customers can deposit EMI against their loan whenever they want, no need to wait at long ques in NBFC’s offices.</p>
    
                                    
                                </div>
                            </div>
                        </div><!--end col-->
                        
                        <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center">
                                <div class="icons text-primary text-center mx-auto">
                                    <i class="uil uil-credit-card-search d-block rounded h3 mb-0"></i>
                                </div>
    
                                <div class="card-body p-0 content">
                                    <h5 class="mt-4"><a href="javascript:void(0)" class="title text-dark">Increase Footfall</a></h5>
                                    <p class="text-muted">With cash management services you enjoy more foot falls at your store, it helps you in getting more revenue from other services.</p>
    
                                    
                                </div>
                            </div>
                        </div><!--end col-->
                        
                        <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center">
                                <div class="icons text-primary text-center mx-auto">
                                    <i class="uil uil-ruler-combined d-block rounded h3 mb-0"></i>
                                </div>
    
                                <div class="card-body p-0 content">
                                    <h5 class="mt-4"><a href="javascript:void(0)" class="title text-dark">Seamless Settlement</a></h5>
                                    <p class="text-muted">Whether it is outside of banking hours or on public holidays, cash management services allow you to quickly convert physical cash into digital cash.</p>
    
                                    
                                </div>
                            </div>
                        </div><!--end col-->
                        
                        <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center">
                                <div class="icons text-primary text-center mx-auto">
                                    <i class="uil uil-exposure-alt d-block rounded h3 mb-0"></i>
                                </div>
    
                                <div class="card-body p-0 content">
                                    <h5 class="mt-4"><a href="javascript:void(0)" class="title text-dark">Quick Fund Settlement</a></h5>
                                    <p class="text-muted">The service is directly lined to partner’s server; the bill gets quickly settled whenever any customer makes any cash deposit against any EMI.</p>
    
                                    
                                </div>
                            </div>
                        </div><!--end col-->
                        
                        <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center">
                                <div class="icons text-primary text-center mx-auto">
                                    <i class="uil uil-clock d-block rounded h3 mb-0"></i>
                                </div>
    
                                <div class="card-body p-0 content">
                                    <h5 class="mt-4"><a href="javascript:void(0)" class="title text-dark">Safe &amp; Secure</a></h5>
                                    <p class="text-muted">Digital payments are conducted over encrypted and safe mechanisms, thus ensuring conversion of cash from physical to digital remains genuinely secure.</p>
    
                                    
                                </div>
                            </div>
                        </div><!--end col-->
                    </div><!--end row-->
                </div><!--end container-->
    
    
    
    
                <section class="padding_50 bg-light mt-0 mt-md-5" style="    background: #fff !important;">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-12 text-center">
                            <div class="section-title mb-4 pb-2">
                                <h4 class="title mb-4"><span class="text-primary fw-bold">EMI &amp; Cash</span> Collection Partners</h4>
                                <p class="text-muted">Happy Pay has integrated with 70+ NBFCs, Financial Institutions and E-Commerce companies for whom cash can be collected at Happy Pay stores.</p>
    
                                <!-- <p class="text-muted para-desc mx-auto mb-0">Start working with <span class="text-primary fw-bold">Landrick</span> that can provide everything you need to generate awareness, drive traffic, connect.</p> -->
                            </div>
                        </div><!--end col-->
                    </div><!--end row-->
    
                    <div class="owl-carousel owl-loaded owl-drag">
                          
                          
                          
                          
                          
                          
                          
                          
                          
                          
                          
                          
                          
                          
    
                          
    
    
                          
    
                          
    
                          
    
                          
    
                          
                          
    
    
                    <div class="owl-stage-outer"><div class="owl-stage" style="transform: translate3d(-2702px, 0px, 0px); transition: all 0.25s ease 0s; width: 6306px;"><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/8.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/9.jpg" class="" alt=""></div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div>  <img src="images/emi/10.jpg" class="" alt=""></div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/11.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/12.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/13.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/14.jpg" class="" alt=""> </div></div><div class="owl-item" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/1.jpg" class="" alt=""> </div></div><div class="owl-item" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/2.jpg" class="" alt=""> </div></div><div class="owl-item" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/3.jpg" class="" alt=""> </div></div><div class="owl-item" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/4.jpg" class="" alt=""> </div></div><div class="owl-item" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/5.jpg" class="" alt=""> </div></div><div class="owl-item active" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/6.jpg" class="" alt=""> </div></div><div class="owl-item active" style="width: 215.2px; margin-right: 10px;"><div>   <img src="images/emi/7.jpg" class="" alt=""> </div></div><div class="owl-item active" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/8.jpg" class="" alt=""> </div></div><div class="owl-item active" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/9.jpg" class="" alt=""></div></div><div class="owl-item active" style="width: 215.2px; margin-right: 10px;"><div>  <img src="images/emi/10.jpg" class="" alt=""></div></div><div class="owl-item" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/11.jpg" class="" alt=""> </div></div><div class="owl-item" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/12.jpg" class="" alt=""> </div></div><div class="owl-item" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/13.jpg" class="" alt=""> </div></div><div class="owl-item" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/14.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/1.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/2.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/3.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/4.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/5.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div> <img src="images/emi/6.jpg" class="" alt=""> </div></div><div class="owl-item cloned" style="width: 215.2px; margin-right: 10px;"><div>   <img src="images/emi/7.jpg" class="" alt=""> </div></div></div></div><div class="owl-nav disabled"><button type="button" role="presentation" class="owl-prev"><span aria-label="Previous">‹</span></button><button type="button" role="presentation" class="owl-next"><span aria-label="Next">›</span></button></div><div class="owl-dots"><button role="button" class="owl-dot"><span></span></button><button role="button" class="owl-dot active"><span></span></button><button role="button" class="owl-dot"><span></span></button></div></div>
                </div><!--end container-->
            </section>
    
    
    
    
                <div class="container mt-100 mt-60">
                    <div class="row align-items-center">
                        <div class="col-lg-5 col-md-6">
                            <img src="../../../../assets/images/EMI-image-2.png" class="img-fluid rounded-md shadow-lg" alt="">
                        </div><!--end col-->
    
                        <div class="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                            <div class="section-title text-md-start text-center ms-lg-4">
                                <h4 class="title mb-4">Cash Deposit in ICICI Bank Accounts</h4>
                                <p class="text-muted mb-0 para-desc">A unique business opportunity by <span class="text-primary fw-bold">Happy Pay</span> wherein you can accept cash deposits for ICICI Bank account holders and earn commission on every transaction.</p>
                                
                                <div class="d-flex align-items-center text-start mt-4 pt-2">
                                    <div class="text-primary h4 mb-0 me-3 p-3 rounded-md shadow bg-white">
                                        <i class="uil uil-capture"></i>
                                    </div>
                                    <div class="flex-1">
                                        <a href="javascript:void(0)" class="text-dark h6">Instant bank account top-up as soon as the transaction is done</a>
                                    </div>
                                </div>
    
                                <div class="d-flex align-items-center text-start mt-4">
                                    <div class="text-primary h4 mb-0 me-3 p-3 rounded-md shadow bg-white">
                                        <i class="uil uil-file"></i>
                                    </div>
                                    <div class="flex-1">
                                        <a href="javascript:void(0)" class="text-dark h6">Can deposit amount in bank 24/7. No fixed banking hours</a>
                                    </div>
                                </div>
    
                                <div class="d-flex align-items-center text-start mt-4">
                                    <div class="text-primary h4 mb-0 me-3 p-3 rounded-md shadow bg-white">
                                        <i class="uil uil-credit-card-search"></i>
                                    </div>
                                    <div class="flex-1">
                                        <a href="javascript:void(0)" class="text-dark h6">Instant commission on every transaction</a>
                                    </div>
                                </div>
    
    
    
                                <div class="d-flex align-items-center text-start mt-4">
                                    <div class="text-primary h4 mb-0 me-3 p-3 rounded-md shadow bg-white">
                                        <i class="uil uil-folder-check"></i>
                                    </div>
                                    <div class="flex-1">
                                        <a href="javascript:void(0)" class="text-dark h6">Fully secured, OTP is triggered on the mobile number</a>
                                    </div>
                                </div>
    
    
                                <div class="d-flex align-items-center text-start mt-4">
                                    <div class="text-primary h4 mb-0 me-3 p-3 rounded-md shadow bg-white">
                                        <i class="uil uil-analysis"></i>
                                    </div>
                                    <div class="flex-1">
                                        <a href="javascript:void(0)" class="text-dark h6">Free beneficiary name verification before transaction to ensure right transaction</a>
                                    </div>
                                </div>
    
    
                            </div>
                        </div><!--end col-->
                    </div><!--end row-->
                </div><!--end container-->
            </section>


            <div class="advisor-area bg-f9f9f9 pt-100" style="background-color:#fff;">
                <div class="container">
                    <div class="section-title">
                
                        <h2>EMI & Cash Collection Partners</h2>

                            <p>Happy Pay has integrated with 70+ NBFCs, Financial Institutions and E-Commerce companies for whom cash can be collected at Happy Pay stores.</p>
                    </div>
                    <div class="advisor-slides">
                        <owl-carousel-o [options]="advisorSlides">
                            <ng-template carouselSlide *ngFor="let item of instructors">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <div class="col-lg-2 col-md-12">
                                            <div class="advisor-image">
                                                <img src="../../../../../assets/images/NPCI-Logo.png" alt="image">
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-md-12">
                                            <div class="advisor-image">
                                                <img src="../../../../../assets/images/NSDL-Payments-Bank.png" alt="image">
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-md-12">
                                            <div class="advisor-image">
                                                <img src="../../../../../assets/images/Tata-Sky-Logo.png" alt="image">
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-md-12">
                                            <div class="advisor-image">
                                                <img src="../../../../../assets/images/airtel-payments-banks.png" alt="image">
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-md-12">
                                            <div class="advisor-image">
                                                <img src="../../../../../assets/images/Amazon-Easy.png" alt="image">
                                            </div>
                                        </div>
            
                                        <div class="col-lg-2 col-md-12">
                                            <div class="advisor-image">
                                                <img src="../../../../../assets/images/ICICI-Bank-Logo.png" alt="image">
                                            </div>
                                        </div>
                                 
                                    </div>
                                </div>
                            </ng-template>
                            
                        </owl-carousel-o>
                    </div>
                </div>
            </div>



            <div class="container mt-100 mt-60">
                <div class="row align-items-center">
                    <div class="col-lg-5 col-md-6">
                        <img src="../../../../assets/images/EMI-image-2.png" class="img-fluid rounded-md shadow-lg" alt="">
                    </div><!--end col-->

                    <div class="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div class="section-title text-md-start text-center ms-lg-4">
                            <h4 class="title mb-4">Cash Deposit in ICICI Bank Accounts</h4>
                            <p class="text-muted mb-0 para-desc">A unique business opportunity by <span class="text-primary fw-bold">Happy Pay</span> wherein you can accept cash deposits for ICICI Bank account holders and earn commission on every transaction.</p>
                            
                            <div class="d-flex align-items-center text-start mt-4 pt-2">
                                <div class="text-primary h4 mb-0 me-3 p-3 rounded-md shadow bg-white">
                                    <i class="uil uil-capture"></i>
                                </div>
                                <div class="flex-1">
                                    <a href="javascript:void(0)" class="text-dark h6">Instant bank account top-up as soon as the transaction is done</a>
                                </div>
                            </div>

                            <div class="d-flex align-items-center text-start mt-4">
                                <div class="text-primary h4 mb-0 me-3 p-3 rounded-md shadow bg-white">
                                    <i class="uil uil-file"></i>
                                </div>
                                <div class="flex-1">
                                    <a href="javascript:void(0)" class="text-dark h6">Can deposit amount in bank 24/7. No fixed banking hours</a>
                                </div>
                            </div>

                            <div class="d-flex align-items-center text-start mt-4">
                                <div class="text-primary h4 mb-0 me-3 p-3 rounded-md shadow bg-white">
                                    <i class="uil uil-credit-card-search"></i>
                                </div>
                                <div class="flex-1">
                                    <a href="javascript:void(0)" class="text-dark h6">Instant commission on every transaction</a>
                                </div>
                            </div>



                            <div class="d-flex align-items-center text-start mt-4">
                                <div class="text-primary h4 mb-0 me-3 p-3 rounded-md shadow bg-white">
                                    <i class="uil uil-folder-check"></i>
                                </div>
                                <div class="flex-1">
                                    <a href="javascript:void(0)" class="text-dark h6">Fully secured, OTP is triggered on the mobile number</a>
                                </div>
                            </div>


                            <div class="d-flex align-items-center text-start mt-4">
                                <div class="text-primary h4 mb-0 me-3 p-3 rounded-md shadow bg-white">
                                    <i class="uil uil-analysis"></i>
                                </div>
                                <div class="flex-1">
                                    <a href="javascript:void(0)" class="text-dark h6">Free beneficiary name verification before transaction to ensure right transaction</a>
                                </div>
                            </div>


                        </div>
                    </div><!--end col-->
                </div><!--end row-->
            </div>





            <div id="section_footer">
                <section class=" d-table w-100 footer_new_section" id="home section_footer" style="padding: 55px 0px;">
                            <div class="container">
                                <div class="row mt-5 align-items-center">
                                    <div class="col-lg-6 col-md-7">
                                        <div class="title-heading">
                                            <h4 class="heading mb-3">Download <span class="text-primary fw-bold">Happy Pay</span> application from Google play-store</h4>
                                            <p class="para-desc text-muted">Signup and create your account. In 48 hours you can start your own business and increase your income</p>
                                            <div class="mt-4">
                                                <a href="https://play.google.com/store/apps/details?id=in.Happy Pay.app" target="_blank" class="btn btn-primary mt-2"><i class="uil uil-google-play"></i> Play Store</a>
                                            </div>
                                        </div>
                                    </div><!--end col-->
                
                                    <div class="col-lg-6 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
                                        <div class="text-md-end text-center ms-lg-4">
                                            <img src="../../../../assets/images/application.png" class="img-fluid" alt="">
                                        </div>
                                    </div>
                                </div><!--end row-->
                            </div><!--end container-->
                        </section>
                
                
                
                        
                    <!-- common on all pages -->
                
                        <section class="section bg-cta" id="lead_form" style="background: url('../../../../assets/images/Common-Image-Last-on-the-Page.jpg') center center;opacity: 0.5;">
                            <div class="bg-overlay"></div>
                            <div class="container">
                                <div class="row align-items-center">
                                     <div class="col-lg-4 col-md-5 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <div class="card border-0 rounded">
                                            <div class="card-body">
                                                <form class="" >
                                                    <h5>Join Now!</h5>
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <div class="mb-3">
                                                                <label class="form-label">Name <span class="text-danger">*</span></label>
                                                                <div class="form-icon position-relative">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user fea icon-sm icons"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                                                    <input type="text" class="form-control ps-5" placeholder="Name" name="name" required="">
                                                                </div>
                                                            </div>
                                                        </div><!--end col-->
                        
                                                        <div class="col-lg-12">
                                                            <div class="mb-3">
                                                                <label class="form-label">Email <span class="text-danger">*</span></label>
                                                                <div class="form-icon position-relative">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail fea icon-sm icons"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                                                                    <input type="email" class="form-control ps-5" placeholder="Email" name="email" required="">
                                                                </div>
                                                            </div>
                                                        </div><!--end col-->
                        
                                                        <div class="col-lg-12">
                                                            <div class="mb-3">
                                                                <label class="form-label">Phone <span class="text-danger">*</span></label>
                                                                <div class="form-icon position-relative">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone fea icon-sm icons"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                                                                    <input type="tel" pattern="[0-9]{10}" id="number" class="form-control ps-5" name="phone" placeholder="Phone (Enter 10 Digits)" required="">
                                                                </div>
                                                            </div>
                                                        </div><!--end col-->
                
                
                                                        <div class="col-lg-12">
                                                            <div class="mb-3">
                                                                <label class="form-label">Join as <span class="text-danger">*</span></label>
                                                                <div class="form-icon position-relative">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user fea icon-sm icons"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                                                    <select type="drop-down" id="option" class="form-control ps-5" name="position" placeholder="Join as" required="">
                                                                            <option value="Retailer">Retailer</option>
                                                                            <option value="Distributor">Distributor</option>
                                                                            <option value="Super_Distributor">Super Distributor</option>
                                                                            <option value="Whitelable_Partner">Whitelable Partner</option>
                                                                            <option value="API">API</option>
                                                                          </select>
                                                                </div>  
                                                            </div>
                                                        </div><!--end col-->
                                                    <!--  <div class="col-lg-12">
                                                            <img src="captcha.php" width="220" height="60" />
                                                            <input type="text" class="form-control ps-5" size="6" maxlength="5" name="captcha_1" value="" placeholder="Enter 5 digits here">
                                                       </div>
                                                    -->
                                                    <input type="hidden" value="https://Happy Pay.in/Happy Pay-retailer.php" name="url">
                                                                                            <input type="hidden" value="" name="campaign">
                                                         <input type="hidden" value="Happy Pay-retailer" name="page_name">
                                                        <div class="col-lg-12 mt-2 mb-0">
                                                            <div class="d-grid">
                                                                <button type="submit" class="btn btn-primary">Register Now</button>
                                                            </div>
                                                        </div><!--end col-->
                                                    </div>
                                                </form>  
                                            </div>
                                        </div>
                                    </div><!--end col-->
                                    <div class="col-lg-8 col-md-7 col-12">
                                        <div class="section-title">
                                            <h4 class="title title-dark text-white mb-4">Happy Pay</h4>
                                            <p class="para-desc para-dark mb-0 text-light">Become a part of the fastest growing network of Independent Business Owners and become financially independent.</p>
                                        </div>
                                        <div class="row" id="counter">
                                            <div class="col-md-3 col-6 mt-4 pt-2">
                                                <div class="counter-box">
                                                    <i class="uil uil-graduation-cap title-dark text-light h2"></i>
                                                    <h5 class="mb-0 text-white title-dark mt-2"><span class="counter-value" data-target="500">500</span>+</h5>
                                                    <h6 class="counter-head title-dark text-light">Districts Covered</h6>
                                                </div><!--end counter box-->
                                            </div><!--end col-->
                        
                                            <div class="col-md-3 col-6 mt-4 pt-2">
                                                <div class="counter-box">
                                                    <i class="uil uil-book-open title-dark text-light h2"></i>
                                                    <h5 class="mb-0 text-white title-dark mt-2"><span class="counter-value" data-target="1">1</span>Lac+</h5>
                                                    <h6 class="counter-head title-dark text-light">Retail Touch Points</h6>
                                                </div><!--end counter box-->
                                            </div><!--end col-->
                        
                                            <div class="col-md-3 col-6 mt-4 pt-2">
                                                <div class="counter-box">
                                                    <i class="uil uil-user title-dark text-light h2"></i>
                                                    <h5 class="mb-0 text-white title-dark mt-2"><span class="counter-value" data-target="10">10</span>Lacs+</h5>
                                                    <h6 class="counter-head title-dark text-light">Monthly Unique Customers</h6>
                                                </div><!--end counter box-->
                                            </div><!--end col-->
                        
                                            <div class="col-md-3 col-6 mt-4 pt-2">
                                                <div class="counter-box">
                                                    <i class="uil uil-english-to-chinese title-dark text-light h2"></i>
                                                    <h5 class="mb-0 text-white title-dark mt-2"><span class="counter-value" data-target="15">15</span>Cr+</h5>
                                                    <h6 class="counter-head title-dark text-light">Daily Transaction Volume</h6>
                                                </div><!--end counter box-->
                                            </div><!--end col-->
                                        </div><!--end row-->
                                    </div><!--end col-->
                
                                   
                                </div><!--end row-->
                            </div><!--end container-->
                        </section>
                        </div>